import { updateCurrentCompanySettings } from '@Actions';
import { useSettings } from '@innovyze/stylovyze';
import { useDispatch } from 'react-redux';
import { CompanySettingsFull } from './GeneralSettingsUtils';

export default function useSetGeneralSettingsFields() {
	const { setSettings } = useSettings();

	const dispatch = useDispatch();
	const setGeneralSettingsFields = (
		newSettings: Partial<CompanySettingsFull>,
	) => {
		dispatch(updateCurrentCompanySettings(newSettings));
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		setSettings(newSettings);
	};

	return setGeneralSettingsFields;
}
